import { render, staticRenderFns } from "./TotalsFloatingWidget.vue?vue&type=template&id=9363eb96&scoped=true"
import script from "./TotalsFloatingWidget.vue?vue&type=script&lang=js"
export * from "./TotalsFloatingWidget.vue?vue&type=script&lang=js"
import style0 from "./TotalsFloatingWidget.vue?vue&type=style&index=0&id=9363eb96&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9363eb96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9363eb96')) {
      api.createRecord('9363eb96', component.options)
    } else {
      api.reload('9363eb96', component.options)
    }
    module.hot.accept("./TotalsFloatingWidget.vue?vue&type=template&id=9363eb96&scoped=true", function () {
      api.rerender('9363eb96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/TotalsFloatingWidget.vue"
export default component.exports